
  export const startRepeatingAlert = (timeoutRef,seconds,selectedSound,notificationSounds,dispatch,setLastAlertTime) => {
  if (timeoutRef.current) {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = null;
  }
  timeoutRef.current = setTimeout(function repeatAlert() {
    const audio = new Audio(notificationSounds[selectedSound]);
    audio.play().catch(e => console.error("Audio play failed:", e));
    dispatch(setLastAlertTime(new Date().toISOString()));
    timeoutRef.current = setTimeout(repeatAlert, seconds* 1000);
  }, seconds *  1000);
};



// export const setupAlertTimerOnRefresh = ({lastAlertTime,user,selectedSound,notificationSounds,dispatch,setLastAlertTime,timeoutRef}) => {
//   if (!lastAlertTime) return;
//   if (!user?.permissions?.enableAlertSound) return;
//   if (!user?.permissions?.enableAlertSoundForIncomingOrders) return;

//   const seconds = user?.incomingOrdersAlertTime || 30;
//   const elapsed = new Date().getTime() - new Date(lastAlertTime).getTime();
//   const timeLeft = Math.max(seconds * 1000 - elapsed, 0);

//   if (!timeoutRef.current) {
//     timeoutRef.current = setTimeout(function repeatAlert() {
//       const audio = new Audio(notificationSounds[selectedSound]);      
//       audio.play().catch((e) => console.error("Audio play failed:", e));
//       dispatch(setLastAlertTime(new Date().toISOString()));
//       timeoutRef.current = setTimeout(repeatAlert, seconds * 1000);
//     }, timeLeft);
//   }
// };


export const setupAlertTimerOnRefresh = ({
  lastAlertTime,
  user,
  selectedSound,
  notificationSounds,
  dispatch,
  setLastAlertTime,
  timeoutRef
}) => {
  if (!lastAlertTime) return;
  if (!user?.permissions?.enableAlertSound) return;
  if (!user?.permissions?.enableAlertSoundForIncomingOrders) return;
  const seconds = user?.incomingOrdersAlertTime || 30;
  const elapsed = new Date().getTime() - new Date(lastAlertTime).getTime();
  const timeLeft = Math.max(seconds * 1000 - elapsed, 0);

  if (!timeoutRef.current) {
    timeoutRef.current = setTimeout(async function repeatAlert() {
      try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();        
        const response = await fetch(notificationSounds[selectedSound]);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

        const source = audioContext.createBufferSource();
        source.buffer = audioBuffer;
        source.connect(audioContext.destination);
        source.start(0);
        dispatch(setLastAlertTime(new Date().toISOString()));
        timeoutRef.current = setTimeout(repeatAlert, seconds * 1000);
      } catch (e) {
        console.error("Audio play failed:", e);
      }
    }, timeLeft);
  }
};

